/**
 * EVIAL — Partner Program earnings calculator
 *
 * Правила (подтверждены 19.08.2026):
 *  Sales Partner — плоская ставка по достигнутой ступени, на ВСЮ месячную сумму:
 *      до $1,000 → 25% | $1,001–$3,000 → 35% | свыше $3,000 → 40%
 *  Creator Program — $20 за одобренное видео + $200, если при 20+ видео одобрены все
 *      (заявленная «база $600» = 20×$20 + $200), плюс разовый бонус за просмотры
 *      на каждое видео по таблице 30-дневных просмотров.
 *
 * Меняются только константы ниже — разметку трогать не нужно.
 */
(function () {
  'use strict';

  var TIERS = [
    { upTo: 1000, rate: 0.25, label: 'Level 1' },
    { upTo: 3000, rate: 0.35, label: 'Level 2' },
    { upTo: Infinity, rate: 0.4, label: 'Level 3' },
  ];

  var VIEW_BONUS = [
    { label: 'Under 5K', bonus: 20 },
    { label: '5K – 10K', bonus: 30 },
    { label: '10K – 15K', bonus: 40 },
    { label: '15K – 20K', bonus: 50 },
    { label: '20K – 25K', bonus: 100 },
    { label: '25K – 50K', bonus: 150 },
    { label: '50K – 100K', bonus: 250 },
    { label: '100K – 250K', bonus: 400 },
    { label: '250K – 500K', bonus: 700 },
    { label: '500K – 1M', bonus: 1200 },
    { label: '1M+', bonus: 2000 },
  ];

  /* До какой ступени доводим слайдер «типичных» просмотров. Выше — это уже не
     типичный ролик, а прорывной: обещать такое на каждое видео нельзя.
     Индекс 6 = «50K – 100K». Поднять планку — поменять одно число. */
  var TYPICAL_VIEWS_CAP = 6;

  var PER_VIDEO = 20;
  var FULL_APPROVAL_BONUS = 200;
  var FULL_APPROVAL_MIN_VIDEOS = 20;
  var PAYOUT_THRESHOLD = 300;

  var money = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  function tierFor(sales) {
    for (var i = 0; i < TIERS.length; i++) {
      if (sales <= TIERS[i].upTo) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }

  /** Подсвеченное значение внутри строки-подписи под крупной цифрой */
  function v(text) {
    return '<var>' + text + '</var>';
  }

  /** Заливка трека слайдера слева от бегунка — одинаково в Safari и Chrome */
  function paint(input) {
    var min = Number(input.min) || 0;
    var max = Number(input.max) || 100;
    var pct = max === min ? 0 : ((Number(input.value) - min) / (max - min)) * 100;
    input.style.setProperty('--fill', pct + '%');
  }

  function init(root) {
    if (root.dataset.calcReady === 'true') return;
    root.dataset.calcReady = 'true';

    var $ = function (sel) {
      return root.querySelector(sel);
    };

    /* ---------- Вкладки ---------- */
    var tabs = root.querySelectorAll('.aff-calc__tab');
    var panels = root.querySelectorAll('.aff-calc__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.panel;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.panel === target;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      });
    });

    /* ---------- Sales Partner ---------- */
    var salesInput = $('#calc-sales');

    function renderSales() {
      var sales = Number(salesInput.value);
      var tier = tierFor(sales);
      var commission = sales * tier.rate;
      var atMax = sales >= Number(salesInput.max);

      $('#calc-sales-val').textContent = money.format(sales) + (atMax ? '+' : '');
      $('#calc-total').textContent = money.format(commission) + (atMax ? '+' : '');

      $('#calc-sales-sub').innerHTML =
        'at ' +
        v(money.format(sales) + (atMax ? '+' : '')) +
        ' in monthly sales &middot; ' +
        v(Math.round(tier.rate * 100) + '%') +
        ' commission &middot; ' +
        v(tier.label) +
        ' &middot; paid monthly';

      var note;
      if (sales === 0) {
        note = 'Move the slider to see what your audience could generate.';
      } else if (tier.upTo === Infinity) {
        note = 'You are at the top rate. Every extra dollar earns 40%.';
      } else {
        var gap = tier.upTo + 1 - sales;
        var nextRate = Math.round(TIERS[TIERS.indexOf(tier) + 1].rate * 100);
        note =
          'You are ' + money.format(gap) + ' of monthly sales away from ' + nextRate + '%.';
      }
      if (commission > 0 && commission < PAYOUT_THRESHOLD) {
        note +=
          ' Payouts start once your balance reaches ' +
          money.format(PAYOUT_THRESHOLD) +
          ' — anything below that rolls over.';
      }
      $('#calc-next').textContent = note;

      paint(salesInput);
    }

    salesInput.addEventListener('input', renderSales);

    /* ---------- Creator Program ---------- */
    var vidInput = $('#calc-videos');
    var viewInput = $('#calc-views');
    viewInput.max = String(Math.min(TYPICAL_VIEWS_CAP, VIEW_BONUS.length - 1));

    function renderCreator() {
      var videos = Number(vidInput.value);
      var band = VIEW_BONUS[Number(viewInput.value)];

      var base = videos * PER_VIDEO;
      var extra = videos >= FULL_APPROVAL_MIN_VIDEOS ? FULL_APPROVAL_BONUS : 0;
      var bonuses = videos * band.bonus;
      var total = base + extra + bonuses;

      $('#calc-videos-val').textContent = String(videos);
      $('#calc-views-val').textContent = band.label;

      $('#calc-creator-total').textContent = money.format(total);
      $('#calc-creator-sub').innerHTML =
        'at ' +
        v(videos + (videos === 1 ? ' approved video' : ' approved videos')) +
        ' &middot; ' +
        v(band.label) +
        ' views each &middot; paid by the ' +
        v('10th');

      $('#calc-base').textContent = money.format(base);
      $('#calc-bonus').textContent = money.format(bonuses);
      $('#calc-extra').textContent = extra ? money.format(extra) : '—';

      var row = $('#calc-extra-row');
      if (row) row.classList.toggle('is-off', !extra);

      var note;
      if (videos === 0) {
        note = 'Set how many videos you could deliver in a month.';
      } else if (videos < FULL_APPROVAL_MIN_VIDEOS) {
        note =
          FULL_APPROVAL_MIN_VIDEOS -
          videos +
          ' more approved videos unlock the ' +
          money.format(FULL_APPROVAL_BONUS) +
          ' full-approval bonus.';
      } else {
        note = 'At 25+ creatives a month for three months you move up to Silver.';
      }
      if (videos > 0) {
        note +=
          ' A single breakout video can add up to ' +
          money.format(VIEW_BONUS[VIEW_BONUS.length - 1].bonus) +
          '+ on top of this.';
      }
      $('#calc-creator-next').textContent = note;

      paint(vidInput);
      paint(viewInput);
    }

    vidInput.addEventListener('input', renderCreator);
    viewInput.addEventListener('input', renderCreator);

    renderSales();
    renderCreator();
  }

  function boot() {
    document.querySelectorAll('.aff-calc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify перерисовывает секции в редакторе темы — переинициализируемся
  document.addEventListener('shopify:section:load', boot);
})();
